<template>
  <div>
    <b-form-group>
      <b-row>
        <b-col>
          <h5>{{ $t('Customers/Max customers') + ' ' + this.dataDiagram.cur_users + '/' + this.dataDiagram.max_users}}</h5>
          <b-progress variant="success" animated class="mb-3"
          v-b-popover.hover.top="this.dataDiagram.cur_users + '/' + this.dataDiagram.max_users"
          :value="this.dataDiagram.cur_users"
          :max="this.dataDiagram.max_users"/>
        </b-col>
        <b-col>
          <h5>{{ $t('Accounts/Max accounts')  + ' ' + this.dataDiagram.cur_accounts + '/' + this.dataDiagram.max_accounts}}</h5>
          <b-progress variant="success" animated
          v-b-popover.hover.top="this.dataDiagram.cur_accounts + '/' + this.dataDiagram.max_accounts"
          :value="this.dataDiagram.cur_accounts"
          :max="this.dataDiagram.max_accounts"/>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group :label="$t('Build')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="text" v-model="build" disabled/>
          </b-form-group>
        </b-col>
        <b-col :key="rerenderLicense">
          <b-form-group :label="$t('End date license')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <flat-picker
            :isDisabled="true"
            @ready="(dp) => {dp.setDate($root.getMomentWithTZDelta(dataDiagram.till ? dataDiagram.till : new Date()/1000 ).toDate())}"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col style="margin-left:0.70rem">
          <md-button class="md-raised" @click="refresh()" >
            {{ $t('Refresh')}} <i class="fas fa-lg fa-sync-alt"  variant="light"/>
          </md-button>
        </b-col>
      </b-row>
    </b-form-group>

    <b-tabs pills card>
      <b-tab active :title="$t('State of the system')">
        <b-row class="mb-3">
          <b-table small
            :items="ramStatItems"
            :fields="ramStatFields">
          </b-table>
        </b-row>
        <b-form-group :label="$t('Top 10 of processes')" label-align="center" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select :options="optionRamStat" v-model="curRamStat"/>
        </b-form-group>
        <b-table striped hover small responsive v-if="curRamStat === 1"
          :items="topProcessesCPUItems"
          :fields="topProcessesFields">
        </b-table>
        <b-table striped hover small responsive v-if="curRamStat === 2"
          :items="topProcessesMEMItems"
          :fields="topProcessesFields">
        </b-table>
      </b-tab>
      <b-tab :title="$t('Base statistics')">
        <b-row>
          <b-col cols="5">
            <b-form-group label="Queries" label-align="center" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="queries" disabled/>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <chartbar-component :chartdata="dataBaseStatQueries" :options="options" v-if="isBaseStatistics"/>
          </b-col>
          <b-col>
            <chartbar-component :chartdata="dataBaseStatThreads" :options="options" v-if="isBaseStatistics"/>
          </b-col>
        </b-row>
      </b-tab>
      <b-tab :title="$t('Session information')">
        <b-row>
          <b-col cols="3" md="3" lg="2" xl="1">
            <md-button v-if="curSession === 3" class="md-raised" @click="dropRadiusSession" >{{ $t('Drop session') }}</md-button>
          </b-col>
          <b-col cols="3" md="3" lg="2" xl="1">
            <md-button v-if="curSession === 3" class="md-raised" @click="disconnectRadiusSession" >{{ $t('Send PoD') }}</md-button>
          </b-col>
          <b-col cols="5" md="5" lg="3" xl="2" style="margin-top:0.3rem">
            <b-form-select :options="optionSession" v-model="curSession"/>
          </b-col>
        </b-row>
        <b-table striped hover small responsive v-if="curSession === 1"
          :items="restConnectionsItems"
          :fields="restConnectionsFields">
        </b-table>
        <b-table striped hover small responsive v-if="curSession === 2"
          :items="coreConnectionsItems"
          :fields="coreConnectionsFields">
        </b-table>
        <div v-if="curSession === 3">
          <table-manager @filterChanged="filterChanged"  @paginationChanged="paginationChanged" :options="optionsTM"/>
          <basic-table striped hover small responsive
            :filter="filter"
            :items="radiusItems"
            :fields="radiusFields"
            :select-mode="'single'"
            selectable
            @RowSelected="onRowSelected">
          </basic-table>
          <TableManagerBottom style="margin:5px" ref="pagination"
          :totalRows="totalRows"
          @input="inputRadiusSessionsPage"
          :perPage="perPage"/>
        </div>
        <b-table striped hover small responsive v-if="curSession === 4"
          :items="hotspotItems"
          :fields="hotspotFields">
        </b-table>
      </b-tab>
      <b-tab title="Customer portal">
        <div v-if="!isCPService">
          <b-jumbotron :lead="$t('Customer portal service not available')"/>
        </div>
        <div v-if="isCPService">
          <b-table striped hover small responsive class="my-table"
          :items="CPServiceItems"
          :fields="CPServiceFields">
        </b-table>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<style>
.my-table {
  max-height: 420px;
  overflow-y: auto;
}
</style>

<script>
import TableManagerBottom from '@/components/tables/TableManagerBottom'
import axiosInstance from '@/utils/api.js'
export default {
  components: {
    TableManagerBottom
  },
  data () {
    return {
      rerenderLicense: 0,
      perPage: 20,
      optionsTM: {
        isShowAddButton: false
      },
      filter: '',
      isCPService: false,
      isTariffs: false,
      isBaseStatistics: false,
      nowTime: this.$root.setDataWithSelectedTZ().format('YYYY-MM-DD'),
      curRamStat: 1,
      curSession: 3,
      radiusSessionsPage: 1,
      optionSession: [
        {value: 1, text: 'Rest connections'},
        {value: 2, text: 'Core connections'},
        {value: 3, text: 'RADIUS'},
        {value: 4, text: 'Hotspot'}
      ],
      optionRamStat: [
        {value: 1, text: 'CPU'},
        {value: 2, text: 'MEM'}
      ],
      options: {
        legend: {
          display: false
        },
        responsive: false,
        maintainAspectRatio: false
      },
      optionsTariffs: {
        legend: {
          display: false
        },
        responsive: false,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            type: 'time',
            time: {
              unit: 'hour',
              unitStepSize: 1,
              round: 'hour',
              tooltipFormat: 'h:mm:ss a',
              displayFormats: {
                hour: 'MMM D, h:mm A'
              }
            }
          }],
          yAxes: [{
            gridLines: {
              color: 'black',
              borderDash: [2, 5]
            },
            scaleLabel: {
              display: true,
              labelString: 'Speed in Miles per Hour',
              fontColor: 'green'
            }
          }]
        }
      },
      ramStatFields: [
        {key: 'buffers', label: 'Buffers'},
        {key: 'cached', label: 'Cached'},
        {key: 'available', label: 'Available memory'},
        {key: 'free', label: 'Free memory'},
        {key: 'swapCached', label: 'Swap cached'}
      ],
      topProcessesFields: [
        {key: '%CPU', label: '%CPU'},
        {key: '%MEM', label: '%MEM'},
        {key: 'PID', label: 'PID'},
        {key: 'PPID', label: 'PPID'},
        {key: 'Process_name', label: this.$i18n.t('Process name')}
      ],
      radiusFields: [
        {key: 'id', label: this.$i18n.t('Session ID')},
        {key: 'acct_session_id', label: this.$i18n.t('NAS session ID')},
        {key: 'uname', label: this.$i18n.t('Login')},
        {key: 'nas_ip', label: 'NAS IP'},
        {key: 'recv_date', label: this.$i18n.t('Start date'), formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'last_update_date', label: this.$i18n.t('Last update date'), formatter: (val, key, item) => { return val ? this.$root.showDataWithTZDelta(val) : this.$i18n.t('Not installed') }},
        {key: 'called_station_id', label: this.$i18n.t('Called station')},
        {key: 'calling_station_id', label: this.$i18n.t('Calling station')},
        {key: 'framed_ip', label: this.$i18n.t('IP address')},
        {key: 'framed_ip6', label: 'IP address v6'}
      ],
      hotspotFields: [
        {key: 'core_session_id', label: this.$i18n.t('UTM session ID')},
        {key: 'nas_sid', label: this.$i18n.t('NAS session ID')},
        {key: 'web_session_id', label: this.$i18n.t('Web session ID')},
        {key: 'start', label: this.$i18n.t('Start date'), formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'last_update', label: this.$i18n.t('Last update'), formatter: (val, key, item) => { return val ? this.$root.showDataWithTZDelta(val) : this.$i18n.t('Not installed') }},
        {key: 'end', label: this.$i18n.t('End date'), formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'slink_id', label: this.$i18n.t('Link ID')},
        {key: 'ip', label: 'IP'},
        {key: 'login', label: this.$i18n.t('Login')},
        {key: 'balance', label: this.$i18n.t('Balance'), formatter: (val) => { return val.toFixed(2) }}
      ],
      restConnectionsFields: [
        {key: 'connection_status', label: 'Connection status'},
        {key: 'local_ip_port', label: 'Local ip port'},
        {key: 'peer_ip_port', label: 'Peer ip port'}
      ],
      coreConnectionsFields: [
        {key: 'id', label: 'ID'},
        {key: 'type', label: this.$i18n.t('Type')},
        {key: 'sysUser', label: 'PID'},
        {key: 'port', label: this.$i18n.t('Port')},
        {key: 'host', label: 'Host'}
      ],
      CPServiceFields: [
        {key: 'client_ip', label: this.$i18n.t('Client ip')},
        {key: 'change_status_time', label: this.$i18n.t('Change status time')},
        {key: 'expiration', label: this.$i18n.t('Session stat expiration')},
        {key: 'connection_status', label: this.$i18n.t('Connection status')}
      ],
      dateFrom: null,
      dateTo: null,
      selectedTime: null,
      optionsTime: [
        { text: this.$i18n.t('Current Day'), value: 1 },
        { text: this.$i18n.t('Current Week'), value: 2 },
        { text: this.$i18n.t('Current Month'), value: 3 },
        { text: this.$i18n.t('Current Year'), value: 4 },
        { text: this.$i18n.t('Manually'), value: 5 }
      ],
      selectedRadiusSession: null
    }
  },
  methods: {
    filterChanged (val) {
      this.filter = val
      this.$store.dispatch('Dashboard/GET_RADIUS_SESSIONS', {page: 1, filter: this.filter, perPage: this.perPage})
    },
    paginationChanged (val) {
      this.perPage = val
      this.$store.dispatch('Dashboard/GET_RADIUS_SESSIONS', {page: 1, filter: this.filter, perPage: this.perPage})
    },
    refresh () {
      this.$store.dispatch('Users/GET_SYSTEM_USERS_SHORT_DATA')
      this.$store.dispatch('Settings/GET_LICENSE')
      this.$store.dispatch('Dashboard/GET_RAM_MEMORY_STAT')
      this.$store.dispatch('Dashboard/GET_TOP_PROCESS_STATISTICS_CPU')
      this.$store.dispatch('Dashboard/GET_TOP_PROCESS_STATISTICS_MEM')
      this.$store.dispatch('Dashboard/GET_DATA_BASE_STAT')
      this.$store.dispatch('Dashboard/GET_CUSTOMER_PORTAL_MODULE_CONNECTIONS')
      this.$store.dispatch('Dashboard/GET_CORE_INFO')
      this.$store.dispatch('Dashboard/GET_RADIUS_SESSIONS', {page: this.radiusSessionsPage, filter: this.filter, perPage: this.perPage})
    },
    async dropRadiusSession () {
      if (this.selectedRadiusSession) {
        let result = await axiosInstance.put('/additional/drop_radius_session', {session_id: this.selectedRadiusSession.acct_session_id,
          nas_ip: this.selectedRadiusSession.nas_ip})
        if (result.status === 200) {
          this.$root.$emit('makeToasts', 'success', this.$i18n.t('Radius session is dropped'))
          setTimeout(this.refresh, 500)
          this.selectedRadiusSession = null
        } else {
          this.$root.$emit('makeToasts', 'danger', result.data, 'Error')
        }
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Radius session is not selected'), 'Error')
      }
    },
    async disconnectRadiusSession () {
      if (this.selectedRadiusSession) {
        let result = await axiosInstance.put('/additional/disconnect_radius_session', {session_id: this.selectedRadiusSession.acct_session_id,
          nas_ip: this.selectedRadiusSession.nas_ip})
        if (result.status === 200) {
          this.$root.$emit('makeToasts', 'success', this.$i18n.t('Radius session is closed'))
          this.$store.dispatch('Dashboard/GET_RADIUS_SESSIONS', {page: this.radiusSessionsPage, filter: this.filter, perPage: this.perPage})
          this.selectedRadiusSession = null
        } else {
          this.$root.$emit('makeToasts', 'danger', result.data, 'Error')
        }
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Radius session is not selected'), 'Error')
      }
    },
    onRowSelected (selected) {
      this.selectedRadiusSession = selected
    },
    endLicense () {
      this.nowTime = Number(Date.parse(this.nowTime)) / 1000
      let endLicense = this.dataDiagram.till - 2592000
      if (this.nowTime >= endLicense) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('License expires'), 'Error')
      }
    },
    inputRadiusSessionsPage (numPage) {
      this.radiusSessionsPage = numPage
      this.$store.dispatch('Dashboard/GET_RADIUS_SESSIONS', {page: this.radiusSessionsPage, filter: this.filter, perPage: this.perPage})
    }
  },
  computed: {
    build () {
      let build = 'NetUP UTM5+ ' + this.$store.getters['Dashboard/CORE_INFO'].version + '-' + this.$store.getters['Dashboard/CORE_INFO'].build_info
      return build
    },
    ramStatItems () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Dashboard/RAM_MEMORY_STAT']))
      let tmp = [{
        buffers: '',
        cached: '',
        available: '',
        free: '',
        swapCached: ''
      }]
      if (copy.Buffers > 1048576) {
        tmp[0].buffers = (copy.Buffers / 1048576).toFixed(2) + 'Gbyte'
      } else {
        tmp[0].buffers = Math.floor(copy.Buffers / 1024) + 'Mbyte'
      }
      if (copy.Cached > 1048576) {
        tmp[0].cached = (copy.Cached / 1048576).toFixed(2) + 'Gbyte'
      } else {
        tmp[0].cached = Math.floor(copy.Cached / 1024) + 'Mbyte'
      }
      if (copy.MemAvailable > 1048576) {
        tmp[0].available = (copy.MemAvailable / 1048576).toFixed(2) + 'Gbyte'
      } else {
        tmp[0].available = Math.floor(copy.MemAvailable / 1024) + 'Mbyte'
      }
      if (copy.MemFree > 1048576) {
        tmp[0].free = (copy.MemFree / 1048576).toFixed(2) + 'Gbyte'
      } else {
        tmp[0].free = Math.floor(copy.MemFree / 1024) + 'Mbyte'
      }
      if (copy.SwapCached > 1048576) {
        tmp[0].swapCached = (copy.SwapCached / 1048576).toFixed(2) + 'Gbyte'
      } else {
        tmp[0].swapCached = Math.floor(copy.SwapCached / 1024) + 'Mbyte'
      }
      return tmp
    },
    dataBaseStatQueries () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Dashboard/DATA_BASE_STAT']))
      let tmp = {
        labels: ['Questions', 'Slow queries'],
        datasets: [
          {
            label: '',
            barPercentage: 0.5,
            minBarLength: 2,
            backgroundColor: ['rgba(3, 252, 28, 0.3)', 'rgba(252, 3, 236, 0.3)'],
            data: []
          }
        ]
      }
      tmp.datasets[0].data.push(copy.questions)
      tmp.datasets[0].data.push(copy.slow_queries)
      return tmp
    },
    dataBaseStatThreads () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Dashboard/DATA_BASE_STAT']))
      let tmp = {
        labels: ['Threads connected', 'Threads created', 'Threads running'],
        datasets: [
          {
            label: '',
            barPercentage: 0.5,
            minBarLength: 2,
            backgroundColor: ['rgba(0, 0, 0, 0.3)', 'rgba(255, 0, 0, 0.3)', 'rgba(47, 0, 255, 0.3)'],
            data: []
          }
        ]
      }
      tmp.datasets[0].data.push(copy.threads_connected)
      tmp.datasets[0].data.push(copy.threads_created)
      tmp.datasets[0].data.push(copy.threads_running)
      return tmp
    },
    topProcessesMEMItems () {
      return this.$store.getters['Dashboard/TOP_PROCESS_STATISTICS_MEM']
    },
    topProcessesCPUItems () {
      return this.$store.getters['Dashboard/TOP_PROCESS_STATISTICS_CPU']
    },
    radiusItems () {
      return this.$store.getters['Dashboard/RADIUS_SESSIONS']
    },
    hotspotItems () {
      return this.$store.getters['Dashboard/HOTSPOT_SESSIONS']
    },
    restConnectionsItems () {
      return this.$store.getters['Dashboard/REST_CONNECTIONS']
    },
    coreConnectionsItems () {
      let tmp = []
      for (let el of this.$store.getters['Dashboard/CORE_CONNECTIONS']) {
        let newEl = {
          id: el.id,
          type: 0,
          port: el.port,
          host: el.host,
          sysUser: 0
        }
        switch (el.type) {
          case 0:
            newEl.type = 'URFA'
            break
          case 1:
            newEl.type = 'Stream Transport'
            break
          case 2:
            newEl.type = 'NetUP XML Transaction'
            break
          case 3:
            newEl.type = 'IPTV Cluster Connection'
            break
        }
        for (let elUsers of this.$store.getters['Users/SYSTEM_USERS_SHORT_DATA']) {
          if (el.staff_id === elUsers.user_id) {
            newEl.sysUser = elUsers.login + ' (' + elUsers.user_id + ')'
          }
        }
        tmp.push(newEl)
      }
      return tmp
    },
    dataDiagram () {
      let data = this.$store.getters['Settings/LICENSE']
      return data
    },
    queries () {
      return this.$store.getters['Dashboard/DATA_BASE_STAT'].queries
    },
    CPServiceItems () {
      let isError = typeof this.$store.getters['Dashboard/CUSTOMER_PORTAL_MODULE_CONNECTIONS'].error
      let tmp = []
      if (isError === 'string') {
        tmp = this.$store.getters['Dashboard/CUSTOMER_PORTAL_MODULE_CONNECTIONS']
      } else {
        let copy = Object.entries(this.$store.getters['Dashboard/CUSTOMER_PORTAL_MODULE_CONNECTIONS'])
        for (let el of copy) {
          let newEl = {
            client_ip: 0,
            connection_status: 0,
            change_status_time: 0,
            expiration: 0
          }
          newEl.client_ip = el[1].Object.client_ip
          newEl.connection_status = el[1].Object.connection_status
          newEl.change_status_time = this.$root.getMomentWithTZDelta(Number(el[1].Object.change_status_time)).format('YYYY-MM-DD HH:mm')
          newEl.expiration = this.$root.getMomentWithTZDelta(Number(el[1].Expiration) / 1000000).format('YYYY-MM-DD HH:mm')
          tmp.push(newEl)
        }
      }
      return tmp
    },
    totalRows () {
      return this.$store.getters['Dashboard/RADIUS_SESSIONS_TOTAL_ROWS']
    }
  },
  mounted () {
    this.endLicense()
    this.refresh()
  },
  watch: {
    dataDiagram () {
      this.rerenderLicense += 1
    },
    curSession: function (val) {
      switch (val) {
        case 1:
          break
        case 2:
          this.$store.dispatch('Dashboard/GET_CORE_CONNECTIONS')
          break
        case 3:
          this.$store.dispatch('Dashboard/GET_RADIUS_SESSIONS', {page: this.radiusSessionsPage, filter: this.filter, perPage: this.perPage})
          break
        case 4:
          this.$store.dispatch('Dashboard/GET_HOTSPOT_SESSIONS')
          break
      }
    },
    dataBaseStatQueries: function (val) {
      this.isBaseStatistics = true
    },
    CPServiceItems: function (val) {
      let isError = typeof this.CPServiceItems.error
      if (isError === 'string') {
        this.isCPService = false
      } else {
        this.isCPService = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/dashboard/Dashboard.vue